import {ChangeDetectionStrategy, Component, computed, inject, model, ModelSignal, Signal} from "@angular/core";
import {OrderModel} from '../../order/order.model';
import {OrderingContextModel} from '../../ordering-context/ordering-context.model';
import {NgClass} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {CurrencyPipe} from '../../utils/currency.pipe';
import {ActivatableDirective} from '../../ui-elements/activatable.directive';

@Component({
    selector: "woa-tip-selection-panel",
    templateUrl: "./tip-selection-panel.component.html",
    styleUrl: "./tip-selection-panel.component.scss",
    imports: [
        CurrencyPipe,
        NgClass,
        TranslateModule,
        ActivatableDirective
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TipSelectionPanelComponent {
    public orderingContextModel: OrderingContextModel = inject(OrderingContextModel);
    private orderModel: OrderModel = inject(OrderModel);

    public tipAmount: ModelSignal<number> = model.required<number>();
    public tipSelected: ModelSignal<boolean> = model.required<boolean>();

    public showTipInstructions: ModelSignal<boolean> = model<boolean>(false);

    public readonly tipPercentages: Signal<number[]> = computed<number[]>(() => [
        0,
        ...[
            this.orderingContextModel.currentStore().tipPercentage1,
            this.orderingContextModel.currentStore().tipPercentage2,
            this.orderingContextModel.currentStore().tipPercentage3,
            this.orderingContextModel.currentStore().tipPercentage4
        ].filter(p => p)
    ]);

    public readonly tipAmounts: Signal<number[]> = computed<number[]>(() =>
        this.tipPercentages().map(p => Math.round(this.orderModel.orderTotal() * p) / 100));

    public readonly selectedTipIndex: Signal<number> = computed<number>(() =>
        this.tipAmounts().findIndex((amount, i) =>
            amount === this.tipAmount() && (this.tipPercentages()[i] !== 0 || this.tipSelected())));

    public selectTip(index: number): void {
        this.tipAmount.set(this.tipAmounts()[index]);
        this.tipSelected.set(true);
    }
}
